/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'
import { useNavigate, useParams } from 'react-router-dom'
export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [category, setCategory] = useState([])
  const [paths, setPaths] = useState([])
  const { page_id, type } = useParams()
  const getToolTip = async () => {
    const { response } = await AppService.tooltip.get({
      toaster: false,
    })
    if (response) {

      setPaths(response.pages)
    } else {
      setPaths([])
    }
  }
  const getAppTypes = async () => {
    const { response } = await AppService.checklist.filter({
      query: `category=${page_id}`,
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
  }
  const getCategories = async () => {
    const { response } = await AppService.checklistcategory.get({
      toaster: false,
    })
    if (response) {
      setCategory(response.data)
    } else {
      setCategory([])
    }
  }

  useEffect(() => {
    getCategories()
  }, [])

  const handleDelete = async (id) => {
    const { response } = await AppService.checklist.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    paths: paths,
    handleRefresh: onLoad,
    category: category,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Description', accessor: 'description' },
        { Header: 'Instruction', accessor: 'instruction' },
        { Header: 'Point Number', accessor: 'points' },
        { Header: 'Category', accessor: 'category' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'Status', accessor: 'status' },

        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data.name,
        description: data.description,
        points: data.points,
        instruction: data.instruction,
        category: data?.category?.name,
        type: data.type,
        status: data.status,

        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} category={category} paths={paths} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
